import React from 'react';
import type { ChangeEvent } from 'react';
import type { TravelerFormValues } from '../../../../api/reservationInfo';
import type { TravelerFieldRules } from '../utils';

type Props = {
  travelerFieldRules: TravelerFieldRules;
  traveler: TravelerFormValues;
  travelerErrors: Partial<Record<keyof TravelerFormValues, string>>;
  onTextChange: (field: keyof TravelerFormValues) => (e: ChangeEvent<HTMLInputElement>) => void;
  disabled: boolean;
};

const ReservationInfoAirRomanFields = ({
  travelerFieldRules,
  traveler,
  travelerErrors,
  onTextChange,
  disabled
}: Props) => {
  const { isRequired, isVisible } = travelerFieldRules;
  if (!isVisible('flight_first_name_roman') && !isVisible('flight_last_name_roman')) {
    return null;
  }

  const styles = getStyles();

  return (
    <>
      <div style={styles.formGroup}>
        <label htmlFor="traveler-flightLastNameRoman" style={styles.label}>
          姓（ローマ字）
          {(isRequired('flight_first_name_roman') || isRequired('flight_last_name_roman')) && (
            <span style={styles.required}>*</span>
          )}
        </label>
        <input
          id="traveler-flightLastNameRoman"
          type="text"
          style={{
            ...styles.input,
            ...(travelerErrors.flightLastNameRoman ? styles.inputError : {})
          }}
          placeholder="例：YAMADA"
          value={traveler.flightLastNameRoman}
          onChange={onTextChange('flightLastNameRoman')}
          disabled={disabled}
        />
        {travelerErrors.flightLastNameRoman && (
          <span style={styles.errorText}>{travelerErrors.flightLastNameRoman}</span>
        )}
      </div>
      <div style={styles.formGroup}>
        <label htmlFor="traveler-flightFirstNameRoman" style={styles.label}>
          名（ローマ字）
          {(isRequired('flight_first_name_roman') || isRequired('flight_last_name_roman')) && (
            <span style={styles.required}>*</span>
          )}
        </label>
        <input
          id="traveler-flightFirstNameRoman"
          type="text"
          style={{
            ...styles.input,
            ...(travelerErrors.flightFirstNameRoman ? styles.inputError : {})
          }}
          placeholder="例：TARO"
          value={traveler.flightFirstNameRoman}
          onChange={onTextChange('flightFirstNameRoman')}
          disabled={disabled}
        />
        {travelerErrors.flightFirstNameRoman && (
          <span style={styles.errorText}>{travelerErrors.flightFirstNameRoman}</span>
        )}
      </div>
    </>
  );
};

const getStyles = (): Record<string, React.CSSProperties> => ({
  formGroup: {
    marginBottom: '16px'
  },
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: 500,
    marginBottom: '6px',
    color: '#333'
  },
  required: {
    color: '#e74c3c',
    marginLeft: '4px'
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    boxSizing: 'border-box' as const,
    outline: 'none'
  },
  select: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    boxSizing: 'border-box' as const,
    outline: 'none',
    backgroundColor: '#fff',
    cursor: 'pointer'
  },
  inputError: {
    borderColor: '#e74c3c'
  },
  errorText: {
    color: '#e74c3c',
    fontSize: '12px',
    marginTop: '4px',
    display: 'block'
  }
});

export default ReservationInfoAirRomanFields;
